import styled from 'styled-components'

export const TeamWrapper = styled.div`
  margin-top:6vh;
  background-color: #272727a9;
  width:92%;
`;

export const TeamHeader = styled.div`
    border-bottom: 3px solid #fff;
    background-color: #00000052;
    display:flex;
    justify-content: space-between;
    align-items:center;
    font-size: 21px;
`;

export const PrevPage = styled.div`
  cursor:pointer;
  display:flex;
  align-items:center;
  height:55px;
  padding-left:15px;
  padding-right:15px;
`
